import { Consumer } from '~/constants/common/consumer';
import { getHrefWithSource } from '~/hooks/common/selectors/useGetConsumerHref';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

export function generateEvElectricLink(): string {
  return getHrefWithSource(Consumer.GUIDE_TO_BUYING_EV)(
    `${generateSearchLinkFilter({
      filters: { fuelTypes: ['Electric'] }
    })}&p_bnr=ev`
  );
}
